import baseUrl from "./BaseURL";

export class StringConstants {
  PROD = false;

  //contentTypes
  applicationJSON = { "Content-Type": "application/json" };
  apiKey = "AIzaSyCTkF9hPY1CXSk7voqCdHZp7ci-4PG6tHU";
  STRIPE_PUBLIC_KEY = baseUrl.STRIPE_PUBLIC_KEY;
  VAPID_KEY =
    "BDACKdeMs3stdaLDjB0Zx28zWTJyxxXIr8-2PyPecWlpFqhPNUISbHKkWhh6ZUzz0qiEIqr_h6FnESPTpy5jF4E";
  FOOTBALL_ACCESS_TOKEN =
    "gAAAAABmkShWlokJbS9hei4MZvGb2wgZpwpQAHgzCu1KIrbtAP_va39HWQVM_mPlgQvbWV_rwAgK_INWrSWypJ-IIr6e0BAlpfJn2yrJY_J9YE7ZTWzyNUEse2oTBgoDiB3m05XPc349t7z35o_a0JwigrYyOfc3gg==";

  notification = "notification";
  error = "error";
  success = "success";
  warning = "warning";
  info = "info";
  autoHideDuration = 600 * 1000; //in milliseconds

  SEARCH_TIME_OUT = 350;

  //Landing Page
  HOME = "";
  LOGIN = "login";
  REGISTER = "register";
  SET_PASSWORD = "set-password";
  OTP = "otp";
  RESET_PASSWORD = "reset-password";
  DELETE_ACCOUNT = "delete-account";

  //pages
  PRIVACY_POLICY = "privacy-policy";
  DASHBOARD = "dashboard";
  PROFILE = "profile";
  CALCULATOR = "calc";
  PROFESSION_ANALYSIS = "profession-analysis";
  ANALYSIS = "analysis";
  REPORT = "report";
  PRICING = "pricing";
  PAYMENT = "payment";
  SUCCESS = "success";
  FAIL = "fail";
  USER_PROFILE = "my-profile";
  SUBSCRIPTION = "subscription";
  UPDATE_PASSWORD = "update-password";
  VEDAZ_TALK = "vedaz-talk";
  VEDAZ_CHAT = "vedaz-chat";
  COMPATIBILITY = "compatibility";
  TWO_PERSON_COMPATIBILITY_ADMIN = "compatibility-center";
  TWO_PERSON_COMPATIBILITY = "two-person-compatibility";
  GET_PDF = "report-as-pdf";
  ADD_DATA = "add-data";
  CURRENT_NAKSHATRA = "current-nakshatra";
  RAHU_TRANSITS = "rahu-transits";
  RESUME = "resume";
  REPORT_ADMIN = "generate-report";
  USER_MANAGEMENT = "user-management";
  RAG_CHATBOT = "rag-chatbot";
  SETTINGS = "settings";
  OTHER = "other";
  PROMOCODE = "promo-code";
  TASKS = "tasks";
  DATA_DOWNLOAD = "data-download";
  PRODUCT_MANAGEMENT = "banners";
  ARUDHA_PADA = "arudha-pada";
  SHADBALA = "shadbala";
  KARMIC_RESOURCES = "karmic-resources";
  ASPECTS = "aspects";
  ABOUT_US = "about-us";
  ABOUT_VEDAZ = "about-vedaz";
  TIME_ANALYSIS = "time-analysis";
  PROFESSION_PHASED = "profession-phased";
  ASTROCARTOGRAPHY = "astrocartography";
  //components
  BACK = "back";
  MOON = "moon";
  NOTIFICATION = "notification";

  //Email validation Regex
  regex =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

  //Phone Number Regex
  phoneNumber = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;

  // tab value
  ANALYSIS_TAB = "analysis";
  MINERALS_TAB = "minerals";
  MAHADASHA_TAB = "mahadasha";
  PLANET_TAB = "planet-details";
  HOUSES_TAB = "houses";
  FOOTBALL_TAB = "football-position-prediction";
  NAKSHATRA_TAB = "nakshatra-analysis";
  CIRCULAR_CHARTS_TAB = "circular-chart";
  DATA = "Data";
  LEGENDS = "Legends";
  PLANET = "Planet";
  RAYS = "Soul Rays";
  GOOD_TIME = "Good Time";
  PERSONAL_DATA = "Personal Data";
  BAD_TIME = "Bad Time";
  CHANGES_IN_ONE_YEAR = "Significant Changes During Upcoming One Year";
  CHANGES_IN_LIFE_SPAN = "Significant Changes During Life Span";
  COMMON_REPORT = "Common Report";
  PROMPT = "Prompt";

  //Button
  PRIMARY = "primary";
  SECONDARY = "secondary";

  // role

  SUPER_ADMIN = "Super Admin";
  ADMIN = "ADMIN";
  USER = "USER";

  // access type
  BOOK_1 = "book-1";
  BOOK_2 = "book-2";
  SUBSCRIPTION_BASIC = "subscription-basic";
  SUBSCRIPTION_PREMIUM = "subscription-premium";

  // authManager
  // HOME = "Home";
  PAGENOTFOUND = "Page Not Found";

  jpeg = ".jpeg";
  JPEG = ".JPEG";
  JPG = "JPG";
  jpg = ".jpg";
  png = ".png";
  PNG = ".PNG";
  gif = ".gif";
  bmp = ".bmp";
  tiff = ".tiff";

  view = "View";
  download = "Download";
}

let strings = new StringConstants();
export default strings;
